import { Pressable, StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Icon from "react-native-vector-icons/Ionicons";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { BasePage } from "../../genericPages/helpers/BasePage";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../../genericPages/components/PlaceText";
import { BiscainhosFooterLogo, BottomNavigationPadding } from "../../genericPages/components/FindifyNavigation";

export const ScanTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    return (<BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <View style={[styles.container, {
            backgroundColor: PlaceColors(findifyDataContext).background.get(),
        }]} >
            <View style={[styles.intro, { paddingTop: insets.top + 18 }]}>
                <PlaceText style={[styles.title, { color: PlaceColors(findifyDataContext).primary.get() }]}>Leitor</PlaceText>
                <PlaceText style={[styles.subtitle, { color: PlaceColors(findifyDataContext).text.withAlpha(180) }]}>Escolhe o tipo de leitura que pretendes usar.</PlaceText>
            </View>
            <Pressable style={[styles.button, {
            }]} onPress={() => navigation.push('ScanQR')}>
                <View style={[styles.optionCard, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(20), borderColor: PlaceColors(findifyDataContext).primary.withAlpha(45) }]}> 
                    <View style={[styles.roundedButton, { borderColor: PlaceColors(findifyDataContext).primary.get(), backgroundColor: PlaceColors(findifyDataContext).primary.get() }]}> 
                        <Icon size={74} name="qr-code-outline" color="#fff" />
                    </View>
                    <View>
                        <PlaceText style={[styles.buttonText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('scan_tab.read_qr')}</PlaceText>
                        <PlaceText style={[styles.buttonDescription, { color: PlaceColors(findifyDataContext).text.withAlpha(170) }]}>Lê um código QR.</PlaceText>
                    </View>
                </View>
            </Pressable>
            <Pressable style={[styles.button, {
            }]} onPress={() => navigation.push('ScanRA')}>
                <View style={[styles.optionCard, { backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(20), borderColor: PlaceColors(findifyDataContext).primary.withAlpha(45) }]}> 
                    <View style={[styles.roundedButton, { borderColor: PlaceColors(findifyDataContext).primary.get(), backgroundColor: PlaceColors(findifyDataContext).primary.get() }]}> 
                        <Icon size={74} name="scan-outline" color="#fff" />
                    </View>
                    <View>
                        <PlaceText style={[styles.buttonText, { color: PlaceColors(findifyDataContext).text.get() }]}>{t('scan_tab.read_ar')}</PlaceText>
                        <PlaceText style={[styles.buttonDescription, { color: PlaceColors(findifyDataContext).text.withAlpha(170) }]}>Reconhece a estátua ou os azulejos.</PlaceText>
                    </View>
                </View>
            </Pressable>
            <View style={{ width: '100%', paddingBottom: insets.bottom + BottomNavigationPadding }}>
                <BiscainhosFooterLogo findifyDataContext={findifyDataContext} />
            </View>
        </View>
    </BasePage>);
};

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        paddingHorizontal: 20,
    },
    intro: {
        width: '100%',
        paddingBottom: 20,
    },
    title: {
        fontSize: 28,
        fontWeight: '800',
    },
    subtitle: {
        fontSize: 15,
        marginTop: 5,
    },
    button: {
        width: '100%',
        marginBottom: 14,
    },
    optionCard: {
        minHeight: 140,
        borderWidth: 1,
        borderRadius: 20,
        padding: 18,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 18,
    },
    buttonText: {
        fontSize: 20,
        fontWeight: '800',
    },
    buttonDescription: {
        fontSize: 14,
        marginTop: 5,
        lineHeight: 20,
    },
    roundedButton: {
        width: 94,
        height: 94,
        borderRadius: 47,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 2,
    },
})
